import { useContext, useState } from 'react'

import {
  Box,
  Button,
  DragNDrop,
  Icon,
  Modal,
  Text,
} from '@fairfashion/design-system'

import { FeedbackAlertContext } from '../../../../components/FeedbackAlert'
import { ItemResponseDTO } from '../../../../sdk/items/items.types'
import { sdk } from '../../../../services/sdk'

export interface UploadToIAModalProps {
  open: boolean
  onClose: () => void
  selectedItems: ItemResponseDTO[]
}

export const UploadToIaModal = ({
  open,
  onClose,
  selectedItems,
}: UploadToIAModalProps) => {
  const [uploadingInvoice, setUploadingInvoice] = useState(false)
  const [invoiceFiles, setInvoiceFiles] = useState<File[]>([])
  const [invoiceUploadSuccess, setInvoiceUploadSucess] = useState(false)

  const { feedbackAlert } = useContext(FeedbackAlertContext)

  const handleFileChange = (newFiles?: File[]) => {
    if (newFiles) {
      setInvoiceFiles(newFiles)
    } else {
      setInvoiceFiles([])
    }
  }

  const handleUploadFiles = async () => {
    if (invoiceFiles.length === 0) return

    setUploadingInvoice(true)
    try {
      await sdk.invoices.uploadInvoiceFilesToIAParser(
        invoiceFiles,
        selectedItems.map((i) => i.id),
      )
      setInvoiceUploadSucess(true)
      setInvoiceFiles([])

      feedbackAlert(
        `${invoiceFiles.length} arquivo(s) enviado(s) com sucesso para processamento via IA!`,
        'success',
      )

      setTimeout(() => {
        setInvoiceUploadSucess(false)
      }, 5000)
    } catch (error) {
      feedbackAlert(
        'Erro ao enviar arquivos para processamento. Tente novamente.',
        'error',
      )
    } finally {
      setUploadingInvoice(false)
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Enviar Origens por IA"
      width="1000px"
      maxWidth="100%"
    >
      <Box direction="column" gap={3} paddingTop={2} width="100%">
        <Box direction="column" gap={3} width="100%">
          <Box width="100%" direction="column" gap={2}>
            <Text size="small" fontWeight={500}>
              Upload de notas fiscais para processamento por IA
            </Text>

            <DragNDrop
              multiple
              width="100%"
              preview="list"
              onChange={handleFileChange}
              fileType=".pdf, .png, .jpg, .jpeg, .webp, application/pdf, image/png, image/jpeg, image/webp"
              fileTypeError="Tipo de arquivo inválido. Aceitamos apenas PDF e imagens."
              maxSize={5 * 1024 * 1024} // 5MB por arquivo
              maxSizeError="Arquivo muito grande. O limite é 5MB por arquivo."
            />

            {invoiceUploadSuccess && (
              <Box
                padding={2}
                backgroundColor="success"
                borderRadius="8px"
                alignItems="center"
                gap={1}
              >
                <Icon name="check" size={16} color="white" />
                <Text size="small" color="white">
                  Arquivos enviados com sucesso para processamento!
                </Text>
              </Box>
            )}
          </Box>
        </Box>
        <Box gap={2} justifyContent="flex-end" width="100%" marginTop={2}>
          <Button
            onClick={handleUploadFiles}
            loading={uploadingInvoice}
            disabled={invoiceFiles.length === 0}
          >
            <Icon name="upload" color="white" size={16} />
            Enviar para IA{' '}
            {invoiceFiles.length > 0 ? `(${invoiceFiles.length})` : ''}
          </Button>
          <Button onClick={onClose} variant="outlined">
            Cancelar
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
